export default "__VITE_ASSET__D7hrMM_H__"